import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const PLACEHOLDERS = [1, 2, 3];

const Testimonials = () => (
    <section id="testimonials" className="bg-[#F6F5F2] py-24 lg:py-32">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
            <Reveal className="max-w-2xl">
                <p className="font-mono-label text-[11px] tracking-[0.3em] uppercase text-[#8E6C2D] mb-5">
                    Client Testimonials
                </p>
                <h2 className="font-serif-display text-3xl lg:text-4xl font-medium tracking-tight text-[#0B192C] leading-[1.2]">
                    What clients say
                </h2>
                <p className="mt-5 text-base text-slate-600 leading-relaxed">
                    In keeping with professional standards and client confidentiality, no
                    testimonials are displayed until genuine, verified client feedback has been
                    provided. The cards below are placeholders only.
                </p>
            </Reveal>

            <div className="mt-14 grid md:grid-cols-3 gap-6">
                {PLACEHOLDERS.map((n) => (
                    <Reveal key={n} delay={(n - 1) * 0.08}>
                        <blockquote
                            data-testid={`testimonial-placeholder-${n}`}
                            className="h-full bg-white border border-dashed border-[#B89047]/50 p-8 flex flex-col"
                        >
                            <Quote size={22} strokeWidth={1.4} className="text-[#B89047]/70" aria-hidden="true" />
                            <p className="mt-5 text-sm text-slate-400 italic leading-relaxed flex-1">
                                [Testimonial placeholder — verified client feedback will appear
                                here once provided.]
                            </p>
                            <footer className="mt-6 pt-5 border-t border-slate-100">
                                <p className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-slate-400">
                                    Client name withheld — placeholder
                                </p>
                            </footer>
                        </blockquote>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Testimonials;
